//# sourceMappingURL=my-date-range-model.interface.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/mydaterangepicker/dist/interfaces/my-date-range-model.interface.js
// module id = ../../../../mydaterangepicker/dist/interfaces/my-date-range-model.interface.js
// module chunks = vendor